module.exports = __webpack_public_path__ + "img/C04ShieldWall_ua.a04af206.webp";